// extracted by mini-css-extract-plugin
export default {"body":"Header_body__bqeOl"};